var map = {
	"./mensaalberteinstein.png": 8917,
	"./mensaapostel.png": 422,
	"./mensaerft.png": 8977,
	"./mensaerichkaestner.png": 7407,
	"./mensagesamtbergheim.png": 5968,
	"./mensagugy.png": 8153,
	"./mensamonte.png": 9669,
	"./mensaschauerte.png": 2224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6806;